import { AdrollConfigHelperReact } from '../source-config-by-type/AdRoll/adroll-config-helper';
import { AmazonAdsConfigHelper } from '../source-config-by-type/AmazonAds/configHelper';
import { AmplitudeAnalyticsConfigHelper } from '../source-config-by-type/AmplitudeAnalytics/configHelper';
import { AppleSearchAdsConfigHelper } from '../source-config-by-type/AppleSearchAds/configHelper';
import { AppsflyerConfigHelper } from '../source-config-by-type/Appsflyer/appsflyer-config-helper';
import { AsanaConfigHelper } from '../source-config-by-type/Asana/configHelper';
import { AwsDocumentdbConfigHelperReact } from '../source-config-by-type/AwsDocumentDb/configHelper';
import { AzureBlobConfigHelperReact } from '../source-config-by-type/AzureBlob/azure-blob-config-helper';
import { BigQuerySourceConfigHelper } from '../source-config-by-type/Bigquery/big-query-config-helper';
import {
  BraintreePaymentsConfigHelper
} from '../source-config-by-type/BraintreePayments/braintree-payments-config-helper';
import { BrazeConfigHelper } from '../source-config-by-type/Braze/braze-config-helper';
import { ChargebeeConfigHelper } from '../source-config-by-type/Chargebee/chargebee-config-helper';
import { ClevertapConfigHelper } from '../source-config-by-type/Clevertap/clevertap-config-helper';
import { CriteoConfigHelper } from '../source-config-by-type/Criteo/criteo-config-helper';
import { DynamodbConfigHelper } from '../source-config-by-type/DynamoDb/configHelper';
import { ElasticSearchConfigHelper } from '../source-config-by-type/ElasticSearch/configHelper';
import { FbaConfigHelper } from '../source-config-by-type/FacebookAds/configHelper';
import { FbInsightsConfigHelperReact } from '../source-config-by-type/FacebookPages/configHelper';
import { FirebaseAnalyticsConfigHelperReact } from '../source-config-by-type/FireBaseAnalytics/configHelper';
import { FrontConfigHelper } from '../source-config-by-type/Front/configHelper';
import { FtpConfigHelperReact } from '../source-config-by-type/FTP/configHelper';
import { GcsConfigHelper } from '../source-config-by-type/Gcs/configHelper';
import { GoogleAdsReactConfigHelper } from '../source-config-by-type/GoogleAds/configHelper';
import { GoogleAnalyticsConfigHelperReact } from '../source-config-by-type/GoogleAnalytics/configHelper';
import { GoogleAnalytics360ConfigHelper } from '../source-config-by-type/GoogleAnalytics360/configHelper';
import { GoogleAnalytics4ConfigHelperReact } from '../source-config-by-type/GoogleAnalytics4/configHelper';
import {
  GoogleCampaignManagerConfigHelperReact
} from '../source-config-by-type/GoogleCampaignManager/configHelper';
import { DriveConfigHelperReact } from '../source-config-by-type/GoogleDrive/configHelper';
import { GooglePlayConfigHelper } from '../source-config-by-type/GooglePlay/configHelper';
import {
  GoogleSearchConsoleConfigHelperReact
} from '../source-config-by-type/GoogleSearchConsole/configHelper';
import { GoogleSheetsReactConfigHelper } from '../source-config-by-type/GoogleSheets/configHelper';
import {
  InstagramBusinessConfigHelper
} from '../source-config-by-type/InstagramBusiness/instagram-business-config-helper';
import { JiraConfigHelper } from '../source-config-by-type/Jira/jira-config-helper';
import { KafkaConfigHelper } from '../source-config-by-type/Kafka/configHelper';
import { LinkedinAdsConfigHelper } from '../source-config-by-type/LinkedInAds/config-helper';
import { MarketoConfigHelper } from '../source-config-by-type/Marketo/marketo-config-helper';
import { MicrosoftAdsReactConfigHelper } from '../source-config-by-type/MicrosoftAds/configHelper';
import { MixpanelConfigHelper } from '../source-config-by-type/Mixpanel/configHelper';
import { MockLoadConfigHelper } from '../source-config-by-type/MockLoad/config-helper';
import { MongodbConfigHelper } from '../source-config-by-type/MongoDb/configHelper';
import { OutbrainConfigHelper } from '../source-config-by-type/Outbrain/config-helper';
import { PardotConfigHelper } from '../source-config-by-type/Pardot/configHelper';
import { PendoConfigHelper } from '../source-config-by-type/Pendo/pendo-config-helper';
import { PinterestAdsConfigHelper } from '../source-config-by-type/PinterestAds/pinterest-ads-config-helper';
import { RecurlyConfigHelper } from '../source-config-by-type/Recurly/recurly-config-helper';
import { RestApiReactConfigHelper } from '../source-config-by-type/RestApi/rest-api-config-helper';
import { S3ConfigHelperReact } from '../source-config-by-type/S3/configHelper';
import {
  SalesforceMarketingCloudConfigHelper
} from '../source-config-by-type/SalesforceMarketingCloud/salesforce-marketing-cloud-config-helper';
import { SendgridConfigHelper } from '../source-config-by-type/SendGrid/sendgrid-config-helper';
import { ShopifyConfigHelper } from '../source-config-by-type/Shopify/config-helper';
import { SnapchatAdsConfigHelper } from '../source-config-by-type/Snapchat/config-helper';
import { SqlConfigHelperReact } from '../source-config-by-type/SQL/configHelper';
import { StripeConfigHelper } from '../source-config-by-type/Stripe/stripe-config-helper';
import { TaboolaConfigHelperReact } from '../source-config-by-type/taboola/configHelper';
import { TiktokAdsConfigHelper } from '../source-config-by-type/TiktokAds/tiktok-ads-config-helper';
import { TwilioConfigHelper } from '../source-config-by-type/Twilio/twilio-config-helper';
import { TwitterAdsConfigHelper } from '../source-config-by-type/TwitterAds/configHelper';
import { TypeformConfigHelper } from '../source-config-by-type/Typeform/typeform-config-helper';
import { WebhookConfigHelper } from '../source-config-by-type/Webhook/webhook-config-helper';
import { XeroConfigHelper } from '../source-config-by-type/Xero/xero-config-helper';
import { YoutubeAnalyticsConfigHelper } from '../source-config-by-type/YoutubeAnalytics/configHelper';

export const SOURCE_TYPE_CONFIG_HELPERS = {
  'REDSHIFT': SqlConfigHelperReact,
  'POSTGRES': SqlConfigHelperReact,
  'AURORA': SqlConfigHelperReact,
  'MS_SQL': SqlConfigHelperReact,
  'AZURE_SQL': SqlConfigHelperReact,
  'ORACLE': SqlConfigHelperReact,
  'MYSQL': SqlConfigHelperReact,
  'MARIA_DB': SqlConfigHelperReact,
  'MONGODB': MongodbConfigHelper,
  'ATLAS_MONGODB': MongodbConfigHelper,
  'MAILCHIMP_WEBHOOK': WebhookConfigHelper,
  'GITHUB': WebhookConfigHelper,
  'INTERCOM_WEBHOOK': WebhookConfigHelper,
  'SHOPIFY_WEBHOOK': WebhookConfigHelper,
  'SEGMENT': WebhookConfigHelper,
  'SENDGRID_WEBHOOK': WebhookConfigHelper,
  'ANDROID_SDK': WebhookConfigHelper,
  'WEBHOOK': WebhookConfigHelper,
  'KAFKA': KafkaConfigHelper,
  'MIXPANEL': MixpanelConfigHelper,
  'GOOGLE_SHEETS': GoogleSheetsReactConfigHelper,
  'DRIVE': DriveConfigHelperReact,
  'CLEVERTAP': ClevertapConfigHelper,
  'S3': S3ConfigHelperReact,
  'GCS': GcsConfigHelper,
  'GOOGLE_SEARCH_CONSOLE': GoogleSearchConsoleConfigHelperReact,
  'GOOGLE_PLAY_CONSOLE': GooglePlayConfigHelper,
  'APPSFLYER': AppsflyerConfigHelper,
  'GOOGLE_ANALYTICS': GoogleAnalyticsConfigHelperReact,
  'GOOGLE_ANALYTICS_V2': GoogleAnalyticsConfigHelperReact,
  'MICROSOFT_ADS': MicrosoftAdsReactConfigHelper,
  'FACEBOOK_ADS': FbaConfigHelper,
  'ELASTICSEARCH': ElasticSearchConfigHelper,
  'FTP': FtpConfigHelperReact,
  'RESTAPI': RestApiReactConfigHelper,
  'DYNAMODB': DynamodbConfigHelper,
  'SENDGRID': SendgridConfigHelper,
  'TWITTER_ADS': TwitterAdsConfigHelper,
  'MARKETO': MarketoConfigHelper,
  'SHOPIFY': ShopifyConfigHelper,
  'STRIPE': StripeConfigHelper,
  'JIRA_CLOUD': JiraConfigHelper,
  'AMPLITUDE_ANALYTICS': AmplitudeAnalyticsConfigHelper,
  'GOOGLE_CM': GoogleCampaignManagerConfigHelperReact,
  'FACEBOOK_PAGES': FbInsightsConfigHelperReact,
  'MOCK_LOAD': MockLoadConfigHelper,
  'OUTBRAIN': OutbrainConfigHelper,
  'ADROLL': AdrollConfigHelperReact,
  'LINKEDIN_ADS': LinkedinAdsConfigHelper,
  'PINTEREST_ADS': PinterestAdsConfigHelper,
  'CRITEO': CriteoConfigHelper,
  'AWS_RDS_MYSQL': SqlConfigHelperReact,
  'GCP_MYSQL': SqlConfigHelperReact,
  'AZURE_MYSQL': SqlConfigHelperReact,
  'ORACLE_MYSQL': SqlConfigHelperReact,
  'TOKU_DB_MYSQL': SqlConfigHelperReact,
  'AWS_RDS_MARIA_DB': SqlConfigHelperReact,
  'AZURE_MARIA_DB': SqlConfigHelperReact,
  'AWS_RDS_POSTGRES': SqlConfigHelperReact,
  'AWS_AURORA_POSTGRES': SqlConfigHelperReact,
  'GCP_POSTGRES': SqlConfigHelperReact,
  'AZURE_POSTGRES': SqlConfigHelperReact,
  'SF_HEROKU_POSTGRES': SqlConfigHelperReact,
  'AWS_RDS_ORACLE': SqlConfigHelperReact,
  'AWS_RDS_MSSQL': SqlConfigHelperReact,
  'GCP_MS_SQL': SqlConfigHelperReact,
  'CONFLUENT_CLOUD': KafkaConfigHelper,
  'YOUTUBE_ANALYTICS': YoutubeAnalyticsConfigHelper,
  'PARDOT': PardotConfigHelper,
  'SALESFORCE_MARKETING_CLOUD': SalesforceMarketingCloudConfigHelper,
  'APPLE_SEARCH_ADS': AppleSearchAdsConfigHelper,
  'AWS_ELASTICSEARCH': ElasticSearchConfigHelper,
  'GOOGLE_ANALYTICS_360': GoogleAnalytics360ConfigHelper,
  'INSTAGRAM_BUSINESS': InstagramBusinessConfigHelper,
  'BIGQUERY': BigQuerySourceConfigHelper,
  'XERO': XeroConfigHelper,
  'GOOGLE_ANALYTICS_4': GoogleAnalytics4ConfigHelperReact,
  'TABOOLA': TaboolaConfigHelperReact,
  'FIREBASE_ANALYTICS': FirebaseAnalyticsConfigHelperReact,
  'ASANA': AsanaConfigHelper,
  'WORDPRESS_VIA_MYSQL': SqlConfigHelperReact,
  'WOOCOMMERCE_VIA_MYSQL': SqlConfigHelperReact,
  'MAGENTO_VIA_MYSQL': SqlConfigHelperReact,
  'PRESTASHOP_VIA_MYSQL': SqlConfigHelperReact,
  'GOOGLE_ADS': GoogleAdsReactConfigHelper,
  'SNAPCHAT_ADS': SnapchatAdsConfigHelper,
  'CHARGEBEE': ChargebeeConfigHelper,
  'BRAINTREE_PAYMENTS': BraintreePaymentsConfigHelper,
  'RECURLY': RecurlyConfigHelper,
  'FRONT': FrontConfigHelper,
  'TYPEFORM': TypeformConfigHelper,
  'PENDO': PendoConfigHelper,
  'TWILIO': TwilioConfigHelper,
  'TIKTOK_ADS': TiktokAdsConfigHelper,
  'AWS_DOCUMENT_DB': AwsDocumentdbConfigHelperReact,
  'BRAZE': BrazeConfigHelper,
  'AZURE_BLOB': AzureBlobConfigHelperReact,
  'AMAZON_ADS': AmazonAdsConfigHelper,
  'AWS_OPENSEARCH': ElasticSearchConfigHelper
};
